import React, {useEffect, useState} from 'react';
import TableTitle from "../../Helpers/TableTitle";
import AdminTable from "../../Helpers/AdminTable";
import {useDispatch, useSelector} from "react-redux";
import {scheduleAction, scheduleUserAction} from "../../../../store/Slices/Administrator/ScheduleSlice";
import SureModal from "../../../../components/Modals/SureModal";
import AddEditScheduleUsersModal from "../Modals/AddEditScheduleUsersModal";
import { getClubs } from 'src/store/Slices/DropDownSlice';

const SecondTable = ({mnemo, scheduleInfo}) => {
  const itemsSecondTable = [
    {
      key: '1',
      label: 'Редактировать',
      onClick: () => { setIsOpenAddEditModalSecondTable({ open: true, flag: 'edit' }) },
      disabled: !mnemo?.children[1]?.children?.find(el => el.mnemo === 'updateBtn')
    },
    {
      key: '2',
      label: 'Удалить',
      // onClick: () => { setIsOpenDeleteModal(true) },
      onClick: () => { setIsOpenDeleteModal(true) },
      disabled: !mnemo?.children[1]?.children?.find(el => el.mnemo === 'deleteBtn')
    },
  ];
  const [isDeletedSecondTable, setIsDeletedSecondTable] = useState(false)
  const [pageSecondTable, setPageSecondTable] = useState(1)
  const [pageSizeSecondTable, setPageSizeSecondTable] = useState(20)
  const [isOpenAddEditModalSecondTable, setIsOpenAddEditModalSecondTable] = useState({ open: false, flag: '' })
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false)
  const [currentSchedule, setCurrentSchedule] = useState()

  // STORE
  const dispatch = useDispatch()
  const scheduleUsersList = useSelector(state => state.ScheduleSlice.scheduleUsersList)
  const scheduleUsersListLoading = useSelector(state => state.ScheduleSlice.scheduleUsersListLoading)
  const clubs = useSelector(state => state.DropDownSlice.clubs)

  const searchItemsMap = (keys, values) => {
    const formattedItems = {};
    if (keys && values) {
      keys.forEach((key, index) => {
        if (values[index] && values[index][0]) {
          if (key === 'id') {
            formattedItems['idFrom'] = values[index][0];
            formattedItems['idTo'] = values[index][1];
          } else {
            formattedItems[key] = values[index][0];
          }
        }
      });
      return formattedItems;
    }
  };

  const handleTableChange = (pagination, filters, sorter) => {
    const payload = searchItemsMap(Object.keys(filters), Object.values(filters))
    dispatch(scheduleUserAction({
      flag: 'get', value: {
        id: scheduleInfo.id,
        isDeleted: isDeletedSecondTable,
        count: pagination.pageSize,
        offset: pagination.pageSize * (pagination.current - 1),
        orderBy: sorter?.column?.dataIndex,
        isDesc: sorter.order ? sorter.order === 'ascend' ? true : false : undefined,
        ...payload
      }
    }))
    setPageSecondTable(pagination.current)
    setPageSizeSecondTable(pagination.pageSize)
  }

  useEffect(() => {
    if(scheduleInfo) {
      dispatch(scheduleUserAction({flag: 'get', value: { id: scheduleInfo.id }}))
      dispatch(getClubs())
    }
  }, [scheduleInfo])

  const showDeletedItems = (value) => {
    setIsDeletedSecondTable(value)
    dispatch(scheduleUserAction({ flag: 'get', value: { isDeleted: value, id: scheduleInfo.id } }))
    setPageSecondTable(1)
    setPageSizeSecondTable(20)
  }

  const onClickDelete = () => {
    dispatch(scheduleUserAction({ flag: 'delete', value: { id: currentSchedule.id } })).then(() => {
      dispatch(scheduleUserAction({ flag: 'get', value: { id: scheduleInfo.id }}))
      setIsOpenDeleteModal(false)
    })
    setPageSecondTable(1)
    setPageSizeSecondTable(20)
  }
  return (
    <>
      <AddEditScheduleUsersModal
      visible={isOpenAddEditModalSecondTable}
      setVisible={setIsOpenAddEditModalSecondTable}
      scheduleInfo={scheduleInfo}
      setPage={setPageSecondTable}
      setPageSize={setPageSizeSecondTable}
      userInfo={currentSchedule}
      clubId={clubs?.data?.value.find(el => el.label === scheduleInfo.clubName)?.value}
      />
      <SureModal
        visible={isOpenDeleteModal}
        setVisible={setIsOpenDeleteModal}
        onClickYes={onClickDelete}
      />
      <AdminTable
        page={pageSecondTable}
        setPage={setPageSecondTable}
        pageSize={pageSizeSecondTable}
        setPageSize={setPageSizeSecondTable}
        onChange={handleTableChange} //обновить
        loading={scheduleUsersListLoading}
        onClickRowOne={(record) => {
          setCurrentSchedule(record)
        }}
        columns={scheduleUsersList}
        rows={scheduleUsersList?.data?.value?.rows}
        total={scheduleUsersList?.data?.value?.totalCount}
        title={() => (<TableTitle
          isDeleted={isDeletedSecondTable}
          showDeletedItems={showDeletedItems}
          onClickOpenModal={() => {
            setIsOpenAddEditModalSecondTable({open: true, flag: 'add'})
          }}
          mnemoButton={!mnemo?.children[1]?.children?.find(el => el.mnemo === 'insertBtn')}
          mnemoSwitcher={!mnemo?.children[1]?.children?.find(el => el.mnemo === 'isDeletedBtn')}
        />)}
        items={itemsSecondTable}
        isDeleted={isDeletedSecondTable}
        height={250}
      />
    </>
  );
};

export default SecondTable;